let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kGA6m")).then(() => parcelRequire('7AVO9'));